import { useState, useEffect } from "react";
import { connect } from "react-redux";
import Sidebar from "../utilities/Sidebar";
import { changeNav } from "../../../redux/actions/userActions";
import WashupTransaction from "./transaction/WashupTransaction";
import LaundroTransaction from "./transaction/LaundroTransaction";
import CleanproTransaction from "./transaction/CleanproTransaction";
import { getStoreType, timezone } from "../../../dynamicController";
import axios from "axios";
import { updateUser } from "../../../redux/actions/userActions";

const STORETYPE = getStoreType()

const Transaction = ({ transactions, reloads, transfers, user, changeNav, points, filter, subscriptionHistory, token, updateUser }) => {
  const [toggled, setToggled] = useState(false);
  const [selected, setSelected] = useState(filter ? filter : STORETYPE === "cleanpro" ? "All" : "Transaction");

  useEffect(() => {
    if (user && token && points.length <= 0 && reloads.length <= 0 && transfers.length <= 0) {
      axios.get("/api/user/getTransactionList", { headers: { "Content-Type": "application/json", "auth-token": token } })
        .then(res => {
          updateUser({ type: "transaction", pointHistory: res.data.pointHistory, tokenPurchaseHistory: res.data.tokenPurchaseHistory, transferToken: res.data.transferToken })
        })
        .catch(err => {
        })
    }
  }, []);

  const renderDate = (date, timeOnly) => {
    const ascMonth = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    const thisDate = new Date(date);

    let hour24 = "";
    let hour = "";
    let offset = parseInt(timezone(user?.country))

    if (thisDate.getUTCHours() + offset >= 24) {
      hour24 = thisDate.getUTCHours() + offset - 24;
    } else if (thisDate.getUTCHours() + offset < 0) {
      hour24 = thisDate.getUTCHours() + offset + 24;
    } else {
      hour24 = thisDate.getUTCHours() + offset;
    }

    if (hour24 > 12) {
      hour = hour24 - 12;
      if (hour.toString().length === 1) {
        hour = `0${hour}`
      }
    } else {
      hour = hour24;
      if (hour.toString().length === 1) {
        hour = `0${hour}`
      }
    }

    const minute = thisDate.getUTCMinutes().toString().length === 1 ? `0${thisDate.getUTCMinutes()}` : thisDate.getUTCMinutes().toString();

    const day = thisDate.getDate().toString().length === 1 ? `0${thisDate.getDate()}` : thisDate.getDate().toString();

    const month = ascMonth[thisDate.getMonth()];

    const year = thisDate.getFullYear();

    if (timeOnly) {
      return `${hour}:${minute} ${hour24 >= 12 ? "pm" : "am"}`;
    } else {
      return `${hour}:${minute} ${hour24 >= 12 ? "pm" : "am"} | ${day} ${month} ${year}`;
    }
  };

  return (
    <div id="transaction-page">
      <Sidebar toggled={toggled} setToggled={setToggled} />
      {
        STORETYPE === "washup" || STORETYPE === "jomcuci" ? (
          <WashupTransaction user={user} setToggled={setToggled} selected={selected} setSelected={setSelected} renderDate={renderDate} transactions={transactions} reloads={reloads} transfers={transfers} points={points} subscriptionHistory={subscriptionHistory} />
        ) : STORETYPE === "cleanpro" ? (
          <CleanproTransaction user={user} changeNav={changeNav} filter={filter} selected={selected} setSelected={setSelected} renderDate={renderDate} transactions={transactions} reloads={reloads} transfers={transfers} points={points} subscriptionHistory={subscriptionHistory} />
        ) : (
          <LaundroTransaction user={user} setToggled={setToggled} selected={selected} setSelected={setSelected} renderDate={renderDate} transactions={transactions} reloads={reloads} transfers={transfers} points={points} subscriptionHistory={subscriptionHistory} />
        )
      }
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    transactions: state.user.user?.transactions || [],
    reloads: state.user.user?.tokenPurchaseHistory || [],
    transfers: state.user.user?.transferToken || [],
    points: state.user.user?.pointHistory || [],
    subscriptionHistory: state.user.user?.subscriptionHistory || [],
    user: state.user.user,
    token: state.user.token,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeNav: (nav) => dispatch(changeNav(nav)),
    updateUser: (data) => dispatch(updateUser(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Transaction);
